import AddModal from "./add-modal";

export default AddModal;